import { createSelector } from 'reselect'

const getModal = (state, modal) => state.modal[modal] || {}

export const modalVisible = () => createSelector([getModal], modal => !!modal.visible)
